export default __webpack_public_path__ + "static/media/FB_PageConnectGetDetail.5a3aaf75.png";